import Chosen from "../../../forms/Inputs/Select/Chosen";

const RentalPrivate = {
    init() {
        this.el = $("section.Private");

        if (!this.el.length) {
            return;
        }

        Chosen.init(this.el);
        this.selectStatus = this.el.find('select.changeStatus');

        this.bind();
    },

    bind() {
        this.selectStatus.on('change', RentalPrivate.changeStatus);
    },

    bindDiscounts() {
        this.summarySection = $('[module="rental"][section="summary"]');
        this.summaryFormInputs = $('[module="rental"][section="summary"] form footer');

        this.buttonAddDiscount = this.summarySection.find(".add-discount");
        this.buttonCancelDiscount = this.summarySection.find(".cancel-discount");

        this.orderTotalInput = this.summarySection.find('input[id="price_total"]');
        this.discountValueInput = this.summarySection.find(".discount-value input");
        this.discountPercentageInput = this.summarySection.find(".discount-percentage input");
        this.priceTotalResult = this.summarySection.find(".top.price-after .sum .value");

        this.buttonAddDiscount.off('click').on('click', (evt) => this.toggleDiscount(true));
        this.buttonCancelDiscount.off('click').on('click', (evt) => this.toggleDiscount(false));

        this.discountValueInput.off('keyup').on('keyup', this.debounce((evt) => this.changeDiscountValue(evt), 250));
        this.discountPercentageInput.off('keyup').on('keyup', this.debounce((evt) => this.changeDiscountPercentage(evt), 250));

        this.discountValueInput.off('focusin').on('focusin', (evt) => {
            evt.target.select();
        });
        this.discountPercentageInput.off('focusin').on('focusin', (evt) => {
            evt.target.select();
        });
    },

    changeStatus() {
        Rental.load(null, {event: 'changeStatus', value: $(this).val()}, 0);
        return false;
    },

    toggleDiscount(state) {
        this.summarySection.find(".summaryAll").toggleClass("withDiscount", state);

        if (!state) {
            this.reset();
        } else {
            this.discountValueInput.trigger("focus");
        }
        return false;
    },

    changeDiscountValue(evt) {
        const value = this.getInputValue($(evt.currentTarget));

        this.valueController(value).then(() => {
            const value = this.getInputValue($(evt.currentTarget));

            const orderTotal = this.getInputValue(this.orderTotalInput);
            this.discountPercentageInput.val(this.calculateDiscountPercentage(orderTotal, value));

            this.recalculate();
        });
    },

    changeDiscountPercentage(evt) {
        const value = Number($(evt.currentTarget).val());

        this.percentageController(value).then(() => {
            const value = Number($(evt.currentTarget).val());

            const discountValue = this.calculateDiscountValueFromPercentage(value);
            this.discountValueInput.val(discountValue);

            this.recalculate();
        });
    },

    recalculate() {
        const finalValue = this.calculatePriceAfterDiscount();
        this.priceTotalResult.text(this.formatPrice(finalValue));

        this.updateHiddenFields();
    },

    async valueController(value) {
        const orderTotal = this.getInputValue(this.orderTotalInput);

        if (value >= orderTotal) {
            this.discountValueInput.val(orderTotal);
        } else {
            this.discountValueInput.val(value);
        }

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(true);
            }, 250);
        });
    },

    async percentageController(value) {
        if (value > 100) {
            this.discountPercentageInput.val("100");
        }

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(true);
            }, 250);
        });
    },

    reset() {
        this.discountValueInput.val("0");
        this.discountPercentageInput.val("0");
        this.priceTotalResult.text(this.formatPrice(this.orderTotalInput.val()));

        this.summaryFormInputs.find('input[name="discount_percentage"], input[name="discount_value"], input[name="price_after_discount"]').remove();
    },

    formatPrice(price) {
        return new Intl.NumberFormat('sk-SK', {
            style: 'currency',
            currency: 'EUR',
        }).format(price);
    },

    getInputValue(input) {
        return Number($(input).val());
    },

    calculateDiscountPercentage(total, discountValue) {
        if (total <= 0) {
            return 0;
        }

        const discountPercentage = 100 - ((total - discountValue) / total) * 100;
        return discountPercentage.toFixed(2);
    },

    calculateDiscountValueFromPercentage(percentage) {
        const total = this.getInputValue(this.orderTotalInput);
        return ((total * percentage) / 100).toFixed(2);
    },

    calculatePriceAfterDiscount() {
        const total = this.getInputValue(this.orderTotalInput);
        const discount = this.getInputValue(this.discountValueInput);
        return (total - discount).toFixed(2);
    },

    updateHiddenFields() {
        const discountPercentage = this.discountPercentageInput.val();
        const discountValue = this.discountValueInput.val();
        const finalPrice = this.calculatePriceAfterDiscount();

        this.summaryFormInputs.find('input[name="discount_percentage"], input[name="discount_value"], input[name="price_after_discount"]').remove();
        this.summaryFormInputs.append(`<input type="hidden" id="discount_percentage" name="discount_percentage" value="${discountPercentage}">`);
        this.summaryFormInputs.append(`<input type="hidden" id="discount_value" name="discount_value" value="${discountValue}">`);
        this.summaryFormInputs.append(`<input type="hidden" id="price_after_discount" name="price_after_discount" value="${finalPrice}">`);
    },

    debounce(func, delay) {
        let debounceTimer;
        return function (...args) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(this, args), delay);
        };
    }
};

export default RentalPrivate;
